export default "__VITE_ASSET__2bd62d46__"